import React from 'react'
import { Container, Box, Stack, Typography, Link, Paper } from '@mui/material';

import windowsBadge from '../assets/badge-windows-version.png'
// import windows32Badge from '../assets/badge-windows-x86.png'
import macosBadge from '../assets/badge_macos.png'
// import macosUniversalBadge from '../assets/badge_macos_universal.png'
// import macosArmBadge from '../assets/badge_macos_applesilicon.png'
import appStoreBadge from '../assets/badge_ios.svg'
import googlePlayBadge from '../assets/google-play-badge.png'

const badgeHeight = '4rem'

export default function Download() {
  return (
    <>
      <Typography variant="h5" sx={{
        my: 3,
        textAlign: 'center'
      }}>
        Download Wireguard Apps
      </Typography>

      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        spacing={1}
        sx={{ flexWrap: 'wrap' }}
      >

        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://itunes.apple.com/us/app/wireguard/id1451685025?ls=1&mt=12'
        >
          <img
            src={macosBadge}
            alt=''
            style={{ height: badgeHeight }}
          />
        </a>

        <a
          href='https://itunes.apple.com/us/app/wireguard/id1441195209?ls=1&mt=8'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={appStoreBadge}
            alt=''
            style={{ height: badgeHeight }}
          />
        </a>

        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://download.wireguard.com/windows-client/wireguard-installer.exe'
        >
          <img
            src={windowsBadge}
            alt=''
            style={{ height: badgeHeight }}
          />
        </a>

        <a
          href='https://play.google.com/store/apps/details?id=com.wireguard.android'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={googlePlayBadge}
            alt=''
            style={{ height: badgeHeight }}
          />
        </a>

      </Stack>
    </>
  )
}
